import { Button } from "components/ui";
import "./SeeMoreOptions.scss";

const SeeMoreOptions = ({ onClick }) => {
    return <Button className='see-more-button' text={"See more options"} onClick={onClick} />;
};

export default SeeMoreOptions;
